import { Component, OnInit,Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { AppBaseModule } from '../../app-entry/app.base.module';


@Component({
  selector: 'app-wizard-questions-menu',
  templateUrl: './wizard-questions-menu.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss','./wizard-questions-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardQuestionsMenuComponent extends WizardHpBaseComponent implements OnInit {
  @Input() menuAnswerState = "in";
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur : SimulateurComponent, hpService: HpService,
     router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();
  }

 }
